/**
 * @Author: v_jppjpeng
 * @Date: 2024-04-15 07:30:30
 * @Explain: 输入框
 */
import { setTimeOut } from '@/utils/common';
import { isEffectiveValue } from '@/utils/common/dataJudgment';
import { useEffect, useMemo, useRef } from 'react';
import { InputProps, InputRef, Input as TdInput } from 'tdesign-react';

type PropsType = {
  title?: string;
  pattern?: any;
  /** 是否处理0 */
  isZeroDisplay?: boolean;
} & InputProps;

function Input(props: PropsType) {
  const { title, type, pattern, value, autofocus, isZeroDisplay, onChange } =
    props;

  const inputRef = useRef<InputRef>(null);

  const customProps = useMemo(() => {
    const params: InputProps = {};

    // 配置正则时
    if (pattern) {
      params.onChange = (val, context) => {
        let newVal: any = '';
        if (val) {
          if (pattern.test(val)) {
            newVal = val;
          } else {
            newVal = value;
          }
        } else {
          newVal = '';
        }

        onChange?.(newVal, context);
      };
    }

    // 类型为number时
    if (type === 'number') {
      if (isZeroDisplay) {
        params.value = Number(value) === 0 ? '' : value;
        params.onChange = (val, context) => {
          const newVal: any = Number(val) === 0 ? '' : Number(val);
          onChange?.(newVal, context);
        };
      } else {
        params.onChange = (val, context) => {
          let newVal: any = val;
          if (isEffectiveValue(val)) {
            newVal = Number(val);
          }
          onChange?.(newVal, context);
        };
      }
    }

    return params;
  }, [type, pattern, value, isZeroDisplay, onChange]);

  useEffect(() => {
    if (autofocus && inputRef) {
      setTimeOut(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [autofocus]);

  return (
    <div className="default-td-input width-100" title={title ? title : value}>
      <TdInput ref={inputRef} {...props} {...customProps} />
    </div>
  );
}

export default Input;
